import { queryKeys } from '@/lib/queryKeys'
import { useQuery } from '@tanstack/react-query'
import { useErrorHandler } from './common/useErrorHandler'
import { ActiveTenantContext } from '@/context/common/Context'
import { BookingService } from '@/services/Bookings.service'
import { useContext } from 'react'
import { useTenantOptionalService } from './common/useServiceFactory'
import { addYears } from 'date-fns'

export function useOpenBookings() {
  const { tenantId, tenant } = useContext(ActiveTenantContext)

  const getService = useTenantOptionalService(BookingService)
  const bookingsQuery = useQuery({
    queryKey: queryKeys.bookings.all(tenantId || ''),
    queryFn: async () => {
      if (!tenantId || !tenant) return []
      const service = await getService()
      return service.getBookings(new Date(), addYears(new Date(), 1), 'open', tenant.timezone)
    },
    enabled: !!tenantId && !!tenant,
    staleTime: 30 * 1000,
    refetchInterval: (tenant?.refreshDuration || 300) * 1000,
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    retry: 2,
  })

  useErrorHandler(bookingsQuery.isError, 'Fehler beim Laden der Buchungen.')
  return {
    bookings: bookingsQuery.data ?? [],
  }
}
